import { ReactComponent as PlayCircle } from 'assets/icons/icon-play-circle.svg';

export default PlayCircle;
